import { useCallback } from 'react';

import { useAudioTrackContext } from 'components/app/audio-track/_mediator/audio-track.provider';
import { useZoomContext } from './zoom.provider';
import { isNull } from 'components/app/_helpers/_app.helper';

export const useZoomScroll = () => {
  const { zoomTimeout, listenElement, elementsToScroll, listenWheel } = useZoomContext();
  const { wsWave } = useAudioTrackContext();

  const onScroll = useCallback((event: Event) => {
    if (listenWheel.current) return;
    if (isNull(listenElement.current)) listenElement.current = event.target;

    if (event.target === listenElement.current) {
      clearTimeout(zoomTimeout.current!);
      zoomTimeout.current = setTimeout(() => (listenElement.current = null), 200);

      const scroll = (event.target as HTMLDivElement).scrollLeft;
      elementsToScroll.current.forEach((el) => (el.scrollLeft = scroll));
      wsWave.current!.scrollLeft = scroll;
    }
  }, []);

  return { onScroll };
};
